<script>
import { Pagination } from 'element-ui';

export default {
  name: 'pagination2',
  extends: Pagination,

  // Prev: disabled={this.$parent.disabled || this.$parent.internalCurrentPage <= 1}
  // Next: disabled={ this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0 }

  components: {
    Prev: {
      render(h) {
        return (
          <button
            type='button'
            class='btn-prev'
            style={this.$parent.internalCurrentPage <= 1 ? 'display:none' : ''}
            on-click={this.$parent.prev}>
            {
              this.$parent.prevText
                ? <span>{this.$parent.prevText}</span>
                : <i class='el-icon el-icon-arrow-left'></i>
            }
          </button>
        );
      }
    },

    Next: {
      render(h) {
        return (
          <button
            type='button'
            class='btn-next'
            style={this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0 ? 'display:none' : ''}
            on-click={this.$parent.next}>
            {
              this.$parent.nextText
                ? <span>{this.$parent.nextText}</span>
                : <i class='el-icon el-icon-arrow-right'></i>
            }
          </button>
        );
      }
    }
  }
};
</script>

<style lang='less' scoped>

.el-pagination.is-background .btn-next.disabled, .el-pagination.is-background .btn-next:disabled, .el-pagination.is-background .btn-prev.disabled, .el-pagination.is-background .btn-prev:disabled, .el-pagination.is-background .el-pager li.disabled {
  color: #C0C4CC;
  width: 40px !important;
  height: 40px !important;
  border-radius: 45px !important;
}

.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #f4f4f5;
  color: #606266;
  min-width: 40px !important;
  height: 40px !important;
  border-radius: 2px;
  border-radius: 45px !important;
}

.el-pager /deep/ li {
  padding: 0 4px;
  background: #FFF;
  font-size: 13px;
  min-width: 40.5px !important;
  height: 40px !important;
  line-height: 40px !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 45px !important;
}

.el-pagination.is-background .el-pager /deep/ li:not(.disabled).active {
  background-color: #557087 !important;
  color: #FFF;
}

.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager /deep/ li {
  margin: 0 5px;
  background-color: #FFFFFF;
  color: #557087;
  min-width: 30px;
  border-radius: 2px;
  border: 1px solid #557087;
}

</style>



// WEBPACK FOOTER //
// src/framework/components/pagination2/pagination2.vue